import { useEffect, useState } from "react";
import { danmakuSeed } from "../../../mocks/chiagua";

interface Danmaku {
  id: number;
  text: string;
  color: string;
}

const colorClass: Record<string, string> = {
  primary: "text-primary-600 bg-primary-500/10 border-primary-200",
  accent: "text-accent-800 bg-accent-500/10 border-accent-200",
  secondary: "text-secondary-800 bg-secondary-500/10 border-secondary-300",
};

const autoLines = [
  "这也太精彩了叭",
  "蹲反转蹲到半夜",
  "我证据都找好了",
  "前排围观来了",
  "理性吃瓜不站队",
  "笑死根本停不下来",
  "等一个官方回应",
  "这波我站反方",
];

export default function DanmakuWall() {
  const [list, setList] = useState<Danmaku[]>(danmakuSeed);
  const [text, setText] = useState("");
  const [nick, setNick] = useState("匿名瓜友");

  const push = (msg: string) => {
    if (!msg.trim()) return;
    const id = Date.now();
    const color = ["primary", "accent", "secondary"][id % 3];
    setList((prev) => [...prev, { id, text: msg.trim(), color }]);
  };

  useEffect(() => {
    const timer = window.setInterval(() => {
      const color = ["primary", "accent", "secondary"][Math.floor(Math.random() * 3)];
      setList((prev) => {
        const next = [
          ...prev,
          { id: Date.now(), text: autoLines[Math.floor(Math.random() * autoLines.length)], color },
        ];
        return next.slice(-12);
      });
    }, 4200);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <section id="danmaku" className="bg-background-50 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-10 items-center">
          {/* 左侧玩法说明 */}
          <div className="w-full lg:w-2/5">
            <span className="text-primary-600 text-sm font-semibold tracking-widest">DANMAKU</span>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mt-2">弹幕现场 · 实时吐槽</h2>
            <p className="text-foreground-600 text-sm md:text-base mt-3 leading-relaxed">
              实时讨论区汇聚各路吃瓜群众，发一条弹幕就能同步吐槽。不用等滚动，你的弹幕立刻飞起来，和大家一起把情绪顶到最高点。
            </p>

            <div className="mt-6 bg-background-100/70 border border-background-200/70 rounded-2xl p-5">
              <label className="text-foreground-700 text-xs font-medium block mb-1.5">你的昵称</label>
              <input
                value={nick}
                onChange={(e) => setNick(e.target.value)}
                className="w-full bg-background-50 border border-background-200 rounded-xl px-3 py-2 text-sm outline-none focus:border-primary-400 placeholder:text-foreground-400"
                maxLength={12}
              />
              <label className="text-foreground-700 text-xs font-medium block mt-4 mb-1.5">发条弹幕吐槽</label>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  push(`${nick}：${text}`);
                  setText("");
                }}
                className="flex items-center gap-2"
              >
                <input
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                  className="flex-1 bg-background-50 border border-background-200 rounded-full px-4 py-2.5 text-sm outline-none focus:border-primary-400 placeholder:text-foreground-400"
                  placeholder="这瓜你站哪边？"
                  maxLength={40}
                />
                <button
                  type="submit"
                  className="shrink-0 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-5 py-2.5 rounded-full whitespace-nowrap inline-flex items-center gap-1.5 transition-colors cursor-pointer"
                >
                  <i className="ri-send-plane-fill"></i>
                  发射
                </button>
              </form>
              <p className="text-foreground-500 text-xs mt-3">
                💡 试试输入任意文字后点击「发射」，弹幕会出现在右侧现场。
              </p>
            </div>
          </div>

          {/* 右侧弹幕墙 */}
          <div className="w-full lg:w-3/5 bg-gradient-to-br from-background-100 to-accent-500/10 border border-background-200/70 rounded-2xl p-5 md:p-6 min-h-[360px] flex flex-col">
            <div className="flex items-center justify-between mb-4">
              <span className="inline-flex items-center gap-2 text-foreground-800 text-sm font-semibold">
                <i className="ri-chat-3-fill text-accent-600"></i>
                吃瓜现场 · 实时弹幕
              </span>
              <span className="text-foreground-500 text-xs whitespace-nowrap">
                {list.length} 条 · 每4秒滚一条
              </span>
            </div>
            <div className="flex-1 flex flex-col gap-2.5 overflow-hidden relative">
              {list.map((d) => (
                <span
                  key={d.id}
                  className={`w-fit max-w-full inline-flex items-center gap-1.5 border rounded-full px-3.5 py-1.5 text-sm whitespace-nowrap ${colorClass[d.color]}`}
                >
                  {d.text}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}